module.exports = __webpack_public_path__ + "static/teleco_1-3d006862c9bcfa3c796986248495f516.jpg";